var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8 13.7344C8.1375 13.8531 8.5 13.6062 8.5 13.25V1.45625C8.5 1.325 8.45 1.19375 8.34375 1.1125C7.73125 0.625 6.325 0 4.5 0C2.92188 0 1.44688 0.415625 0.565625 0.753125C0.2125 0.890625 0 1.24062 0 1.61875V13.1906C0 13.5625 0.4 13.8219 0.753125 13.7063C1.7375 13.3781 3.29688 13 4.5 13C5.55937 13 6.96875 13.4375 7.8 13.7344ZM10.2 13.7344C11.0312 13.4375 12.4406 13 13.5 13C14.7031 13 16.2625 13.3781 17.2469 13.7063C17.6 13.825 18 13.5625 18 13.1906V1.61875C18 1.24062 17.7875 0.890625 17.4344 0.75625C16.5531 0.415625 15.0781 0 13.5 0C11.675 0 10.2688 0.625 9.65625 1.1125C9.55313 1.19375 9.5 1.325 9.5 1.45625V13.25C9.5 13.6062 9.86562 13.8531 10.2 13.7344Z",
    fill: "#4F46E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBook);
export default __webpack_public_path__ + "static/media/ic_book.d5ca39cf8385e67f1d8b54e79cea7ca5.svg";
export { ForwardRef as ReactComponent };